import React, { useState } from "react";
import classnames from "classnames";
import propTypes from "prop-types";
import Icon from "../icons/Icon";

import "./NavCard.scss";
import { createDataAttributes } from "../../utilities";

const NavCardContainer = ({
  toggleLinkText,
  collapsable,
  children,
  className,
  dataAttrib,
  ...rest
}) => {
  const multipleChildren = Array.isArray(children);
  const [expanded, setExpanded] = useState(!multipleChildren);
  const toggleNavCards = e => {
    e.preventDefault();
    setExpanded(!expanded);
  };
  const classes = classnames(
    "uikit__nav-card__container",
    {
      "uikit__nav-card__expanded": expanded,
      "uikit__nav-card__multiple": multipleChildren && collapsable
    },
    className
  );
  return (
    <div className={classes} {...createDataAttributes(dataAttrib)} {...rest}>
      <div className="uikit__nav-card__expander">
        {collapsable && multipleChildren && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a href="#" onClick={toggleNavCards}>
            <span>{toggleLinkText}</span>
            <Icon icon="farAngleLeft" />
          </a>
        )}
      </div>
      <div className="uikit__nav-card__cards">{children}</div>
    </div>
  );
};

NavCardContainer.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.element]).isRequired,
  expanderText: propTypes.string,
  collapsable: propTypes.bool,
  toggleLinkText: propTypes.string,
  className: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

NavCardContainer.defaultProps = {
  toggleLinkText: "View Quick Links",
  collapsable: true
};

export default NavCardContainer;
